// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"d0698b7e","977":"55bc1294"}[chunkId] + ".chunk.js";
};